import { apiClient } from "./apiClient";

export const exporterService = {
  /**
   * Create a new exporter
   */
  createExporter: async (name: string) => {
    // Get Spain as default country (id: 1)
    const response = await apiClient.post("/exporters/", {
      name,
      country: 1, // Spain by default
      is_member: false,
    });
    return response.data;
  },
};
